import React from 'react';
import Hero from '@/components/Hero';
import GraduatesGallery from '@/components/GraduatesGallery';
import PhotoGallery from '@/components/PhotoGallery';
import LocationMap from '@/components/LocationMap';
import ScrollReveal from '@/components/ScrollReveal';
import ProgramCards from '@/components/ProgramCards';
import ContactForm from '@/components/ContactForm';
import EnrollmentProcess from '@/components/EnrollmentProcess';
import GoogleReviews from '@/components/GoogleReviews';
import CredibilitySection from '@/components/CredibilitySection';
import NextClasses from '@/components/NextClasses';

const Home = () => {
  return (
    <div>
      <Hero />
      <NextClasses />
      <CredibilitySection />
      <ProgramCards />
      <ScrollReveal>
        <PhotoGallery />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <GraduatesGallery />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <GoogleReviews />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <LocationMap />
      </ScrollReveal>
      <ScrollReveal delay={0.2}>
        <ContactForm />
      </ScrollReveal>
    </div>
  );
};

export default Home;
